import {
	type OrderFieldCreateDto,
	type OrderSetupCreateDto,
	type OrderSetupDetailResponseDto,
	type OrderSetupStatusEnum,
	postOrderSetup,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { getOrderSetupKey } from "Settings/Modules/OrderSetup/Api/Query/useOrderSetupListQuery";
import { SettingsPaths } from "Settings/Routes/Routing";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { toast } from "sonner";

const mutationResource = Resources.base.orderSetup.mutation;

export const useCreateOrderSetupMutation = () => {
	const { t } = useResource();
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	return useMutation({
		mutationFn: processResponse(
			(data: {
				marketId: number;
				verticalId: number;
				orderFields?: OrderFieldCreateDto[];
				status?: OrderSetupStatusEnum;
			}) => postOrderSetup(data as OrderSetupCreateDto),
		),
		onError: (error) => {
			console.error(`${t(mutationResource.createOrderSetupError)}`, error);
		},
		onSuccess: (data) => {
			const orderSetup = !!data
				? (data as OrderSetupDetailResponseDto)
				: undefined;

			if (!orderSetup) {
				return;
			}

			toast.success(`${t(mutationResource.createOrderSetupSuccess)}`);
			queryClient.invalidateQueries({
				queryKey: getOrderSetupKey(
					orderSetup.market.id,
					orderSetup.vertical.id,
				),
			});
			navigate(
				SettingsPaths.OrderSetupEdit.path(
					orderSetup.market.id,
					orderSetup.vertical.id,
					orderSetup.id,
				),
			);
		},
	});
};
